export { default } from './svg/square-default.svg';
